import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { authenticatedRequest } from '@core/utils/authenticatedRequest';
import { getStore } from '@core/store';
import { serializeNotifications } from './serializer';

function getUserId() {
  const userStore = getStore('user');
  if (userStore?.state?.current?.id) {
    return userStore.state.current.id;
  }
}

// ============ LOAD NOTIFICATIONS ============
bus.on(constants.EVENTS.INBOX.NOTIFICATIONS_LOAD, (payload = {}) => {
  const requestId = `notifications-${Date.now()}`;

  const userId = getUserId();
  if (!userId) return;

  bus.emit(constants.EVENTS.INBOX.NOTIFICATIONS_LOADING);

  authenticatedRequest(bus, {
    id: requestId,
    url: `${constants.ENDPOINTS.INBOX.NOTIFICATIONS}&userId=${userId}`,
    method: 'GET',
    requiresAuth: true,
    errorEvent: constants.EVENTS.INBOX.NOTIFICATIONS_LOAD_ERROR
  });

  // Écouter la réponse une seule fois
  const responseHandler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);

      const responseData = res.data || res;
      if (responseData?.success || responseData?.statusCode === 200) {
        // API returns { data: { notifications: [...], total, unreadCount } }
        const rawNotifications = responseData?.data?.data || responseData?.data?.notifications || responseData?.data || [];
        const serializedData = serializeNotifications(Array.isArray(rawNotifications) ? rawNotifications : []);
        bus.emit(constants.EVENTS.INBOX.NOTIFICATIONS_LOADED, serializedData);
      } else {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATIONS_LOAD_ERROR, responseData?.error || responseData);
      }
    }
  };

  bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
});

// ============ MARK NOTIFICATION AS READ ============
bus.on(constants.EVENTS.INBOX.NOTIFICATION_MARK_READ, (notificationId) => {
  if (!notificationId) {
    console.error('Notification ID is required to mark as read');
    return;
  }

  const requestId = `mark-read-${notificationId}-${Date.now()}`;

  const userId = getUserId();
  if (!userId) return;

  bus.emit(constants.EVENTS.INBOX.NOTIFICATION_MARKING_READ);

  const url = `${constants.ENDPOINTS.INBOX.MARK_READ.replace(':notificationId', notificationId)}?group=ultraxeno`;

  authenticatedRequest(bus, {
    id: requestId,
    url: url,
    method: 'POST',
    data: { userId },
    requiresAuth: true,
    errorEvent: constants.EVENTS.INBOX.NOTIFICATION_MARK_READ_ERROR
  });

  const responseHandler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);

      const responseData = res.data || res;
      if (responseData?.success || responseData?.statusCode === 200) {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATION_MARKED_READ, notificationId);
      } else {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATION_MARK_READ_ERROR, responseData?.error || responseData);
      }
    }
  };

  bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
});

// ============ MARK ALL NOTIFICATIONS AS READ ============
bus.on(constants.EVENTS.INBOX.NOTIFICATION_MARK_ALL_READ, () => {
  const requestId = `mark-all-read-${Date.now()}`;

  const userId = getUserId();
  if (!userId) return;

  bus.emit(constants.EVENTS.INBOX.NOTIFICATION_MARKING_ALL_READ);

  authenticatedRequest(bus, {
    id: requestId,
    url: `${constants.ENDPOINTS.INBOX.MARK_ALL_READ}?group=ultraxeno`,
    method: 'POST',
    data: { userId },
    requiresAuth: true,
    errorEvent: constants.EVENTS.INBOX.NOTIFICATION_MARK_ALL_READ_ERROR
  });

  const responseHandler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);

      const responseData = res.data || res;
      if (responseData?.success || responseData?.statusCode === 200) {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATION_MARKED_ALL_READ);
      } else {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATION_MARK_ALL_READ_ERROR, responseData?.error || responseData);
      }
    }
  };

  bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
});

// ============ DELETE NOTIFICATION ============
bus.on(constants.EVENTS.INBOX.NOTIFICATION_DELETE, (notificationId) => {
  if (!notificationId) {
    console.error('Notification ID is required to delete');
    return;
  }

  const requestId = `delete-notification-${notificationId}-${Date.now()}`;

  bus.emit(constants.EVENTS.INBOX.NOTIFICATION_DELETING);

  const url = constants.ENDPOINTS.INBOX.DELETE.replace(':notificationId', notificationId);

  authenticatedRequest(bus, {
    id: requestId,
    url: url,
    method: 'DELETE',
    requiresAuth: true,
    errorEvent: constants.EVENTS.INBOX.NOTIFICATION_DELETE_ERROR
  });

  const responseHandler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);

      const responseData = res.data || res;
      if (responseData?.success || responseData?.statusCode === 200) {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATION_DELETED, notificationId);
      } else {
        bus.emit(constants.EVENTS.INBOX.NOTIFICATION_DELETE_ERROR, responseData?.error || responseData);
      }
    }
  };

  bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
});

// ============ FILTER CHANGE ============
bus.on(constants.EVENTS.INBOX.NOTIFICATION_FILTER_CHANGE, (filters) => {
  // This event is handled by the store, but we can also trigger a reload if needed
  if (filters.reload) {
    bus.emit(constants.EVENTS.INBOX.NOTIFICATIONS_LOAD, { filters });
  }
});
